export default {
  title: 'Checkout',
  labels: {
    login: 'Login to use your saved info and loyalty points',
    continue_as_guest: 'or continue as guest',
  },
  buttons: {
    login: 'Login',
    demo_mode: 'Demo Modus',
  },
};
